module.exports = __webpack_public_path__ + "img/cursoLinguas.2842b853.png";